import { Component, OnInit } from '@angular/core';
import { HaSurveyserviceService } from '../../services/HaSurvey.service';
import { HaNewquestion } from '../../models/HaNewQuestion.model';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from '@angular/forms';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { SurveyInsertQuestionModal } from '../../models/SurveyInsertQuestion.model';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-ha-createsurvey',
  templateUrl: './ha-createsurvey.component.html',
  styleUrls: ['./ha-createsurvey.component.css']
})

export class HaCreatesurveyComponent implements OnInit {
  caseGroup: any[];
  questionTypeArray: any[];
  questText: string = "";
  item: any[];
  elementForSingleQuestiontype: HTMLElement;
  elementForMultiQuestiontype: HTMLElement;
  elementForRadioQuestiontype: HTMLElement;
  singleInputBlank: string;
  multiInputBlank: string;
  afterInsertQuestionId: string = "";
  optionOneBlank: string;
  optionTwoBlank: string;
  elementForSelectCase: HTMLElement;
  elementForSelectItem: HTMLElement;
  elementFordownsidediv: HTMLElement;
  radioOk: boolean;
  singleSelectWeight: string = "0";
  multiSelectWeight: string = "0";
  optionOneWeightZero: string = "0";
  optionTwoWeightZero: string = "0";
  formData;
  answerTypeOptions: any[] = [];
  displayAnswerTypeOptions: any[] = [];
  optionType: string = "checkbox";
  categorySelectedForCodes: string;
  selectCaseGroupIdCategory: string = "";
  newQuestion: HaNewquestion;
  displayNewQuestion: HaNewquestion;
  formErrors;
  validationMessages;
  radioOff: boolean;
  elementListInfoHide: HTMLElement;
  slNo = 0;
  mainViewError = new ErrorModel();

  constructor(private _service: HaSurveyserviceService, private router: Router, private fb: FormBuilder) {

  }

  ngOnInit() {
    this.newQuestion = new HaNewquestion();
    this.getCaseGroup();
    this.formData = new FormGroup({
      selectCategories: new FormControl(""),
      selectCase: new FormControl(""),
      selectItem: new FormControl(),
      selectQuestionType: new FormControl(""),
      questionVal: new FormControl(""),
      optionOneText: new FormControl(""),
      optionOneWeight: new FormControl(""),
      option2Text: new FormControl(""),
      option2Weight: new FormControl(""),
      //skills reperesent single answer type question option
      skills: this.fb.array([
        this.addSkillFormGroup()
      ]),
      //skills2 repersent multi answer type question options
      skills2: this.fb.array([
        this.addSkillFormGroup2()
      ]),
      //skills 3 repersent true/false type question type
      skills3: this.fb.array([
        this.addSkillFormGroup3()
      ])
    });
  }

  //code to get list of all case group
  getCaseGroup() {
    this.mainViewError.display = false;
    this._service.getCaseGroup().subscribe(
    (data: any[]) => {
      this.caseGroup = data["caseGroups"];
      this.questionTypeArray = data["selectionModal"];
      this.formData.controls['selectQuestionType'].setValue(this.questionTypeArray[0].index);
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    });
  }

  pushOption(text,weight, optionIndex, type) {
    if (text == "" || weight == undefined || weight == "" || weight == null) {
      alert("Please fill options");
    } else {
      let index = this.answerTypeOptions.filter(i => i.index == optionIndex)[0];
      if (index !== undefined) {
        let indexTwo = this.answerTypeOptions.indexOf(index);
        this.answerTypeOptions.splice(indexTwo, 1);
      }
      this.answerTypeOptions.push({
        "option": text,
        "weight": weight,
        "index": optionIndex
      });

      switch(type) {
        case 0:
          this.multiSelectWeight = "0";
          this.resetOptionWeight();
          break;
        case 1:
          this.singleSelectWeight = "0";
          this.resetOptionWeight();
          break;
        case 2:
          this.resetSingleAndMuti();
          break;
        default:
          alert('ERROR: Case not Valid...');
      }
    }
  }

  resetOptionWeight() {
    this.optionOneWeightZero = "0";
    this.optionTwoWeightZero = "0";
  }

  resetSingleAndMuti() {
    this.singleSelectWeight = "0";
    this.multiSelectWeight = "0";
  }

  //code to add question to survey
  addQuestion(selectCategories,  selectItem, selectQuestionType, questionVal) {
    // if (selectCategories == "6") {
    if (questionVal == "") {
      AlertMessages.Show("Warning", 'Please Add Question!!! ', AlertType.Warning);
    } else if (!(this.answerTypeOptions.length > 0)) {
      AlertMessages.Show("Warning", 'Please Add Question Options!!! ', AlertType.Warning);
    } else {
      this.newQuestion.codeType = selectCategories;
      this.newQuestion.question = questionVal;
      this.newQuestion.caseCodeId = 'jhfhfjhfhjf';
      this.newQuestion.qTypeId = this.questionTypeArray.filter(i => i.index == selectQuestionType)[0].id;
      if (selectQuestionType == "1" || selectQuestionType == "3") {
        this.optionType = "radio";
      }
      if (selectQuestionType == "2") {
        this.optionType = "checkbox";
      }
      let insertModal:SurveyInsertQuestionModal = new SurveyInsertQuestionModal(this.newQuestion,this.answerTypeOptions);

      this._service.insertSurveyQuestion(insertModal).subscribe(
      (data: string) => {
        this.questText = "";
        this.afterInsertQuestionId = data;
        this.selectCaseGroupIdCategory = "";

        AlertMessages.Show("Success", 'Question Saved Successfully ', AlertType.Add);
        this.slNo = this.slNo + 1;
        this.displayNewQuestion = this.newQuestion;

        this.displayAnswerTypeOptions.push({
          "question1": questionVal,
          "options1": this.answerTypeOptions,
          "questionType": selectQuestionType
        });
        this.elementListInfoHide = document.getElementById("listinfohide");
        this.elementListInfoHide.style.display = "none";
        //making thye temporary list empty
        this.answerTypeOptions = [];
        //removing dynamically generated options for multi answewr type question on adding question
        while (( < FormArray > this.formData.get('skills2')).length !== 0) {
          ( < FormArray > this.formData.get('skills2')).removeAt(0);
        }
        //adding deafult option for multi answewr type question on adding question
        ( < FormArray > this.formData.get('skills2')).push(this.addSkillFormGroup2());
        //removing dynamically generated options for single answer type question on adding question
        while (( < FormArray > this.formData.get('skills')).length !== 0) {
          ( < FormArray > this.formData.get('skills')).removeAt(0);
        }
        //adding deafult option for single answewr type question on adding question
        ( < FormArray > this.formData.get('skills')).push(this.addSkillFormGroup());
        //removing dynamically generated options for true/false answer type question on adding question
        while (( < FormArray > this.formData.get('skills3')).length !== 0) {
          ( < FormArray > this.formData.get('skills3')).removeAt(0);
        }
        //adding deafult option for single answewr type question on adding question
        ( < FormArray > this.formData.get('skills3')).push(this.addSkillFormGroup3());
      },
      (error) => {
        AlertMessages.Show('Failed','Could not add question',AlertType.Error);
        this.slNo = this.slNo - 1;
      });
    }
    // }
  }

  //routing to surevey management main component
  routeSurveyCreate() {
    this.router.navigate(['Hospital/HAAdmin/HaSurveymanagementCreate'], {
      queryParams: {}
    });
  }

  //code to give the option type either checkbox or radio based on selection of answer type for question
  answerFormat(questionType: string) {
    this.elementForRadioQuestiontype = document.getElementById('radioanswerselect');
    this.elementForMultiQuestiontype = document.getElementById('multianswerselect');
    this.elementForSingleQuestiontype = document.getElementById('singleanswerselect');
    this.elementForRadioQuestiontype.style.display = questionType == '3' ? 'block' : 'none';
    this.elementForMultiQuestiontype.style.display = questionType == '2' ? 'block' : 'none';
    this.elementForSingleQuestiontype.style.display = questionType == '1' ? 'block' : 'none';
    this.answerTypeOptions = [];
    if (questionType == '1') {
      while (( < FormArray > this.formData.get('skills2')).length !== 0) {
        ( < FormArray > this.formData.get('skills2')).removeAt(0);
      }
      ( < FormArray > this.formData.get('skills2')).push(this.addSkillFormGroup2());
      while (( < FormArray > this.formData.get('skills3')).length !== 0) {
        ( < FormArray > this.formData.get('skills3')).removeAt(0);
      }
      ( < FormArray > this.formData.get('skills3')).push(this.addSkillFormGroup3());
    }
    if (questionType == "2") {
      while (( < FormArray > this.formData.get('skills')).length !== 0) {
        ( < FormArray > this.formData.get('skills')).removeAt(0);
      }
      ( < FormArray > this.formData.get('skills')).reset();
      ( < FormArray > this.formData.get('skills')).push(this.addSkillFormGroup());
      while (( < FormArray > this.formData.get('skills3')).length !== 0) {
        ( < FormArray > this.formData.get('skills3')).removeAt(0);
      }
      ( < FormArray > this.formData.get('skills3')).push(this.addSkillFormGroup3());
    }
    if (questionType == "3") {
      this.radioOk = false;
      while (( < FormArray > this.formData.get('skills')).length !== 0) {
        ( < FormArray > this.formData.get('skills')).removeAt(0);
      }
      ( < FormArray > this.formData.get('skills')).push(this.addSkillFormGroup());
      while (( < FormArray > this.formData.get('skills2')).length !== 0) {
        ( < FormArray > this.formData.get('skills2')).removeAt(0);
      }
      ( < FormArray > this.formData.get('skills2')).push(this.addSkillFormGroup2());
    }
    this.optionOneBlank = "";
    this.optionTwoBlank = "";
    this.multiInputBlank = "";
    this.resetSingleAndMuti();
    this.resetOptionWeight();
    this.singleInputBlank = "";
  }

  // adding code for dynamic option craetions for single answer type question
  addSkillButtonClick(): void {
    ( < FormArray > this.formData.get('skills')).push(this.addSkillFormGroup());
  }

  //basic model for single answer type option
  addSkillFormGroup(): FormGroup {
    return this.fb.group({
      singleQuestionOpt: ['', Validators.required],
      singleSelectWeight: ['0', Validators.required]
    });
  }

  //validation for single answer type question options
  logValidationErrors(group: FormGroup = this.formData): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }
      if (abstractControl instanceof FormArray) {
        for (const control of abstractControl.controls) {
          if (control instanceof FormGroup) {
            this.logValidationErrors(control);
          }
        }
      }
    });
  }

  //remove aoption dynamically for single answer type question code
  removeSkillButtonClick(skillGroupIndex: number): void {
    ( < FormArray > this.formData.get('skills')).removeAt(skillGroupIndex);
    let index = this.answerTypeOptions.filter(ij => ij.index == skillGroupIndex)[0];
    if (index !== undefined) {
      var indexTwo = this.answerTypeOptions.indexOf(index);
      this.answerTypeOptions.splice(indexTwo, 1);
    }
  }

  //adding for muti answer type option
  addSkillButtonClick2(): void {
    ( < FormArray > this.formData.get('skills2')).push(this.addSkillFormGroup2());
  }
  //model for multi answer type option
  addSkillFormGroup2(): FormGroup {
    return this.fb.group({
      multiQuestionOpt: ['', Validators.required],
      multiSelectWeight: ['0', Validators.required]
    });
  }

  //validation for multi answer type option
  logValidationErrors2(group: FormGroup = this.formData): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors2(abstractControl);
      }

      // We need this additional check to get to the FormGroup
      if (abstractControl instanceof FormArray) {
        for (const control of abstractControl.controls) {
          if (control instanceof FormGroup) {
            this.logValidationErrors2(control);
          }
        }
      }
    });
  }

  //removing multi answer type options dynamically
  removeSkillButtonClick2(skillGroupIndex: number): void {
    ( < FormArray > this.formData.get('skills2')).removeAt(skillGroupIndex);
    var index = this.answerTypeOptions.findIndex(ij => ij.index == skillGroupIndex);
    if (index !== undefined) {
      this.answerTypeOptions.splice(index, 1);
    }
  }

  //adding options for true/false type question
  addSkillButtonClick3(): void {
    if (( < FormArray > this.formData.get('skills3')).length == 1) {
      this.radioOff = true;
    }
    ( < FormArray > this.formData.get('skills3')).push(this.addSkillFormGroup3());
  }

  //model for true/false type question options
  addSkillFormGroup3(): FormGroup {
    return this.fb.group({
      optionOneText: ['', Validators.required],
      optionOneWeight: ['0', Validators.required],
      option2Text: ['', Validators.required],
      option2Weight: ['0', Validators.required],
    });
  }

  //validation for true/fasle type question option
  logValidationErrors3(group: FormGroup = this.formData): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors3(abstractControl);
      }

      // We need this additional check to get to the FormGroup
      // in the FormArray and then recursively call this
      // logValidationErrors() method to fix the broken validation
      if (abstractControl instanceof FormArray) {
        for (const control of abstractControl.controls) {
          if (control instanceof FormGroup) {
            this.logValidationErrors3(control);
          }
        }
      }
    });
  }

  //removing true/false type question options
  removeSkillButtonClick3(skillGroupIndex: number): void {
    ( < FormArray > this.formData.get('skills3')).removeAt(skillGroupIndex);
    let index = this.answerTypeOptions.findIndex(ij => ij.index == skillGroupIndex);
    if (index !== undefined) {
      this.answerTypeOptions.splice(index, 1);
    }
    // this.answerTypeOptions.splice(skillGroupIndex,1);
    if (( < FormArray > this.formData.get('skills3')).length == 1) {
      this.radioOff = false;
    }
  }
}
